export function timeAgo(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '';
  const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (s < 45) return 'just now';
  const m = Math.round(s / 60); if (m < 60) return `${m}m`;
  const h = Math.round(m / 60); if (h < 24) return `${h}h`;
  const d = Math.round(h / 24); if (d < 7) return `${d}d`;
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
export const fmtDateTime = (iso: string | null | undefined) => iso ? new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';
export const words = (s: string | null | undefined) => (s ?? '').replace(/_/g, ' ');
export const cap = (s: string) => s ? s[0].toUpperCase() + s.slice(1) : s;
export const intentLabel = (s: string | null | undefined) => s ? cap(words(s)) : 'Unclassified';
export const pct = (n: number) => `${Math.round(n * 100)}%`;
export const CHANNEL: Record<string, string> = { instagram: 'IG', facebook: 'FB', web: 'Web', email: 'Email', playground: 'Test' };
export const CHANNEL_NAME: Record<string, string> = { instagram: 'Instagram', facebook: 'Facebook', web: 'Website chat', email: 'Email', playground: 'Test chat' };
export function initials(name: string | null | undefined) {
  const n = (name ?? '?').replace(/^@/, '').trim();
  const parts = n.split(/[\s._-]+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '?') + (parts[1]?.[0] ?? '')).toUpperCase();
}
export function who(c: { display_name?: string | null; ig_username?: string | null; email?: string | null }) {
  return c.ig_username ? `@${c.ig_username}` : c.display_name ?? c.email ?? 'Customer';
}
